// extracted by mini-css-extract-plugin
export default {"Link":"AppLink_Link__JrHge"};